import { AllCommunityModule, ModuleRegistry } from 'ag-charts-community';

// AG Charts 14 requires explicit module registration for standalone charts
// (donut/line on accuracy and coverage). Integrated grid charts still go through
// AllEnterpriseModule.with(AgChartsCommunityModule) in main.ts.
ModuleRegistry.registerModules(AllCommunityModule);
